// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"a523018b","152":"815a107a","166":"674bd3d2","182":"46baff0e","309":"2bd5c3f4","370":"f1cbc8f6","418":"62d9ce2f","982":"4e2a0d53"}[chunkId] + ".chunk.css";
};